import { render, staticRenderFns } from "./news3.vue?vue&type=template&id=9e7e7446&scoped=true"
import script from "./news3.vue?vue&type=script&lang=js"
export * from "./news3.vue?vue&type=script&lang=js"
import style0 from "./news3.vue?vue&type=style&index=0&id=9e7e7446&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e7e7446",
  null
  
)

export default component.exports